/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioCapsen } from './pages'

type TIdToPageMapStylioCapsen = Record<PageIdStylioCapsen, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_CAPSEN: TIdToPageMapStylioCapsen = {
  [PageIdStylioCapsen.AGE_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/AgeQuestion'),
  },
  [PageIdStylioCapsen.URGE_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capsen/pages/urge/UrgePage'),
  },
  [PageIdStylioCapsen.HAIR_COLOR_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioCapsen.EYES_COLOR_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioCapsen.JEWELRY_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/JewelryQuestion'
      ).then((m) => ({
        default: m.JewelryQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/questions/JewelryQuestion'),
  },
  [PageIdStylioCapsen.BODY_SHAPE_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioCapsen.STYLIO_TO_HELP_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/questions/StylioToHelp'),
  },
  [PageIdStylioCapsen.TALL_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/questions/TallQuestion'),
  },
  [PageIdStylioCapsen.WEIGHT_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/questions/WeightQuestion').then(
        (m) => ({
          default: m.WeightQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/questions/WeightQuestion'),
  },
  [PageIdStylioCapsen.URGE_2_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioCapsen.FEEL_ABOUT_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/FeelAboutQuestion'
      ).then((m) => ({
        default: m.FeelAboutQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/questions/FeelAboutQuestion'),
  },
  [PageIdStylioCapsen.PERCENTAGE_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/PercentageQuestion'
      ).then((m) => ({
        default: m.PercentageQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/questions/PercentageQuestion'),
  },
  [PageIdStylioCapsen.SHOPPING_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/ShoppingQuestion'
      ).then((m) => ({
        default: m.ShoppingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioCapsen.STYLE_MOST_MATTERS_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/StyleMostMattersQuestion'
      ),
  },
  [PageIdStylioCapsen.FAVORITE_COLORS_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_12_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant12'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant12Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant12'
      ),
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_13_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant13'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant13Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant13'
      ),
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_14_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant14'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant14Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant14'
      ),
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_15_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant15'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant15Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant15'
      ),
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_16_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant16'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant16Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant16'
      ),
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_17_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant17'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant17Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant17'
      ),
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_18_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant18'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant18Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant18'
      ),
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_19_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant19'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant19Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/likeOrDislike/LikeOrDislikeVariant19'
      ),
  },
  [PageIdStylioCapsen.STYLES_FEEL_LIKE_YOU_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/StylesFeelLikeYouQuestion'
      ).then((m) => ({
        default: m.StylesFeelLikeYouQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/StylesFeelLikeYouQuestion'
      ),
  },
  [PageIdStylioCapsen.URGE_3_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioCapsen.BRAND_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/questions/BrandQuestion').then(
        (m) => ({
          default: m.BrandQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/questions/BrandQuestion'),
  },
  [PageIdStylioCapsen.FIND_NEW_CLOTHES_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/FindNewClothesQuestion'
      ),
  },
  [PageIdStylioCapsen.NOTHING_TO_WEAR_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/NothingToWearQuestion'
      ),
  },
  [PageIdStylioCapsen.OLD_CLOTHES_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/OldClothesQuestion'
      ).then((m) => ({
        default: m.OldClothesQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/questions/OldClothesQuestion'),
  },
  [PageIdStylioCapsen.COMBINE_CLOTHES_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/CombineClothesQuestion'
      ).then((m) => ({
        default: m.CombineClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/CombineClothesQuestion'
      ),
  },
  [PageIdStylioCapsen.OPTIMIZE_BUDGET_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/OptimizeBudgetQuestion'
      ).then((m) => ({
        default: m.OptimizeBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/questions/OptimizeBudgetQuestion'
      ),
  },
  [PageIdStylioCapsen.URGE_4_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioCapsen.PREPARE_FLOW_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioCapsen.EMAIL_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capsen/pages/email/Email'),
  },
  [PageIdStylioCapsen.EMAIL_CONSENT_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/email/EmailConsent'),
  },
  [PageIdStylioCapsen.SUBSCRIPTIONS_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/subscriptions/SubscriptionPage'
      ).then((m) => ({
        default: m.SubscriptionPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsen/pages/subscriptions/SubscriptionPage'
      ),
  },
  [PageIdStylioCapsen.CANCEL_OFFER_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/cancel-offer/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioCapsen.SUB_UPSELL_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioCapsen.UPSELL_CAPSEN]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsen/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capsen/pages/upsell/Upsell'),
  },
  [PageIdStylioCapsen.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioCapsen.DOWNLOAD_CAPSEN]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsen/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsen/pages/download-app/DownloadDefault'),
  },
}
